/* Broworkshop · estructura común: encabezado, pie, búsqueda, carrito y favoritos */
(function () {
  'use strict';

  const BW = window.BW;
  const { $, $$, esc, money, imgUrl, icon, C, Cart, Wish, ui, catMeta } = BW;
  const page = document.body.dataset.page || '';
  const { R } = BW;
  const shop = (params) => ui.shopUrl(params);
  const policy = (hash = '') => `${R.policies}${hash ? `#${hash}` : ''}`;
  const year = new Date().getFullYear();

  /* ───────────── Plantillas ───────────── */
  const ANNOUNCE = [
    ['truck', 'Envíos a todo el país, de Leticia a La Guajira'],
    ['lock', 'Pago 100% protegido'],
    ...(ui.hasWhatsApp() ? [['wa', `Atención por WhatsApp ${ui.waPretty()}`]] : []),
    ['percent', 'Ofertas todos los días'],
    ['award', 'Calidad garantizada'],
    ['heart', 'Orgullosamente colombianos'],
  ];

  /** Logo: marca (bolsa) + nombre, o el logo completo con el lema. */
  const brandHTML = ({ dark = false, full = false } = {}) => (full
    ? `<a class="brand brand--full" href="${R.home}" aria-label="Broworkshop, ir al inicio">
        <img src="${BW.img(dark ? 'logo-completo-blanco.svg' : 'logo-completo.svg')}" alt="Broworkshop: todo lo que necesitas, en un solo lugar" width="260" height="77" loading="lazy">
      </a>`
    : `<a class="brand" href="${R.home}" aria-label="Broworkshop, ir al inicio">
        <img class="brand__mark" src="${BW.img('logo-marca.svg')}" alt="" width="39" height="48">
        <img class="brand__word" src="${BW.img(dark ? 'logo-texto-blanco.svg' : 'logo-texto.svg')}" alt="Broworkshop" width="135" height="48">
      </a>`);

  const waAttrs = () => `data-wa href="${esc(ui.waLink(ui.currentWaText()))}" target="_blank" rel="noopener"`;

  const socialLinks = () => {
    const nets = [['instagram', 'Instagram'], ['facebook', 'Facebook'], ['tiktok', 'TikTok']]
      .filter(([k]) => C.social && C.social[k]);
    const wa = ui.hasWhatsApp() ? `<a class="social social--wa" ${waAttrs()} aria-label="WhatsApp">${icon('wa')}</a>` : '';
    return nets.map(([k, label]) => `<a class="social" href="${esc(C.social[k])}" target="_blank" rel="noopener" aria-label="${label}">${icon(k)}</a>`).join('') + wa;
  };

  function headerHTML() {
    const items = ANNOUNCE.map(([ic, t]) => `<span class="announce__item">${icon(ic)}${t}</span><span class="announce__dot" aria-hidden="true">✦</span>`).join('');
    return `
    <a class="skip-link" href="#main">Saltar al contenido</a>
    <div class="announce">${ui.marquee(items.repeat(2), { speed: 70 })}</div>
    <div class="tricolor" aria-hidden="true"><i></i><i></i><i></i></div>
    <header class="site-header" data-header>
      <div class="container header__inner">
        <button class="icon-btn header__menu" type="button" data-open="menu" aria-label="Abrir menú" aria-expanded="false">${icon('menu')}</button>
        ${brandHTML()}
        <nav class="nav" aria-label="Principal">
          <a class="nav__link" href="${R.home}" data-nav="inicio">Inicio</a>
          <a class="nav__link" href="${R.shop}" data-nav="tienda">Tienda</a>
          <div class="nav__item" data-mega-root>
            <button class="nav__link nav__trigger" type="button" aria-expanded="false" aria-controls="mega">Categorías ${icon('chev-down')}</button>
            <div class="mega" id="mega" data-mega hidden>
              <div class="mega__inner">
                <div class="mega__grid" data-mega-grid>${'<span class="sk sk--pill"></span>'.repeat(9)}</div>
                <div class="mega__side" data-mega-promo></div>
              </div>
            </div>
          </div>
          <a class="nav__link" href="${shop({ oferta: 1 })}" data-nav="ofertas">Ofertas <span class="nav__hot">%</span></a>
          <a class="nav__link" href="${policy()}" data-nav="politicas">Políticas</a>
        </nav>
        <button class="search-trigger" type="button" data-open="search" aria-label="Buscar productos">
          ${icon('search')}<span class="search-trigger__text" data-typer>Buscar productos…</span><kbd>/</kbd>
        </button>
        <div class="header__actions">
          <button class="icon-btn only-sm" type="button" data-open="search" aria-label="Buscar">${icon('search')}</button>
          <button class="icon-btn hide-sm" type="button" data-open="wish" aria-label="Favoritos">${icon('heart')}<span class="badge" data-wish-count hidden>0</span></button>
          <button class="icon-btn icon-btn--cart" type="button" data-open="cart" data-cart-target aria-label="Carrito de compras">${icon('bag')}<span class="badge" data-cart-count hidden>0</span></button>
        </div>
      </div>
    </header>`;
  }

  function drawersHTML() {
    return `
    <div class="drawer drawer--right" data-drawer="cart" hidden>
      <div class="drawer__scrim" data-close></div>
      <aside class="drawer__panel" role="dialog" aria-modal="true" aria-labelledby="cart-title" tabindex="-1">
        <div class="drawer__head">
          <h2 id="cart-title" data-cart-title>Tu carrito</h2>
          <button class="icon-btn" type="button" data-close aria-label="Cerrar carrito">${icon('x')}</button>
        </div>
        <div class="drawer__body" data-cart-body><div class="drawer__loading"><span class="spinner"></span></div></div>
        <div class="drawer__foot" data-cart-foot hidden>
          <p class="cart-save" data-cart-save hidden></p>
          <div class="cart-total"><span>Subtotal</span><b data-cart-subtotal>$ 0</b></div>
          <p class="cart-note">${icon('truck')}<span>Envíos a todo el país. El envío se calcula al finalizar la compra.</span></p>
          <a class="btn btn--primary btn--lg btn--block" data-checkout href="#">${icon('lock')}Finalizar compra</a>
          ${ui.hasWhatsApp() ? `<a class="btn btn--wa btn--block" data-wa-cart href="#" target="_blank" rel="noopener">${icon('wa')}Pedir por WhatsApp</a>` : ''}
          <button class="btn btn--ghost btn--block" type="button" data-close>Seguir comprando</button>
          ${ui.paymentsHTML({ compact: true }) || `<p class="cart-secure">${icon('shield')}Pago protegido y cifrado por Shopify</p>`}
        </div>
      </aside>
    </div>

    <div class="drawer drawer--right" data-drawer="wish" hidden>
      <div class="drawer__scrim" data-close></div>
      <aside class="drawer__panel" role="dialog" aria-modal="true" aria-labelledby="wish-title" tabindex="-1">
        <div class="drawer__head">
          <h2 id="wish-title" data-wish-title>Tus favoritos</h2>
          <button class="icon-btn" type="button" data-close aria-label="Cerrar favoritos">${icon('x')}</button>
        </div>
        <div class="drawer__body" data-wish-body></div>
      </aside>
    </div>

    <div class="drawer drawer--left" data-drawer="menu" hidden>
      <div class="drawer__scrim" data-close></div>
      <aside class="drawer__panel" role="dialog" aria-modal="true" aria-label="Menú" tabindex="-1">
        <div class="drawer__head">
          ${brandHTML()}
          <button class="icon-btn" type="button" data-close aria-label="Cerrar menú">${icon('x')}</button>
        </div>
        <div class="drawer__body">
          <nav class="mnav" aria-label="Menú móvil">
            <a href="${R.home}">${icon('home')}Inicio</a>
            <a href="${R.shop}">${icon('store')}Toda la tienda</a>
            <a href="${shop({ oferta: 1 })}">${icon('percent')}Ofertas</a>
            <button type="button" data-open="wish">${icon('heart')}Favoritos</button>
            <a href="${policy()}">${icon('file')}Políticas</a>
            ${ui.hasWhatsApp() ? `<a class="mnav__wa" ${waAttrs()}>${icon('wa')}WhatsApp <small>${ui.waPretty()}</small></a>` : ''}
            <a ${ui.contactAttrs()}>${icon('chat')}Formulario de contacto</a>
          </nav>
          <p class="mnav__title">Categorías</p>
          <div class="mnav__cats" data-mnav-cats>${'<span class="sk sk--pill"></span>'.repeat(6)}</div>
        </div>
      </aside>
    </div>

    <div class="drawer drawer--search" data-drawer="search" hidden>
      <div class="drawer__scrim" data-close></div>
      <div class="search-panel drawer__panel" role="dialog" aria-modal="true" aria-label="Buscar productos" tabindex="-1">
        <form class="search-box" action="${R.search}" role="search" data-search-form>
          ${icon('search')}
          <input type="search" name="q" data-search-input data-autofocus autocomplete="off" enterkeyhint="search"
            placeholder="¿Qué estás buscando hoy?" aria-label="Buscar productos"
            role="combobox" aria-expanded="false" aria-controls="search-results" aria-autocomplete="list">
          <button class="icon-btn" type="button" data-close aria-label="Cerrar búsqueda">${icon('x')}</button>
        </form>
        <div class="search-body">
          <div data-search-idle>
            <p class="eyebrow-sm">Búsquedas populares</p>
            <div class="chips" data-search-popular></div>
            <p class="eyebrow-sm">Categorías</p>
            <div class="chips" data-search-cats></div>
          </div>
          <ul class="search-results" id="search-results" role="listbox" aria-label="Resultados" data-search-results hidden></ul>
          <a class="search-all" href="${R.shop}" data-search-all hidden><span>Ver todos los resultados</span>${icon('arrow')}</a>
        </div>
      </div>
    </div>`;
  }

  function footerHTML() {
    const L = C.legal || {};
    const contact = [
      L.correo ? `<li>${icon('mail')}<a href="mailto:${esc(L.correo)}">${esc(L.correo)}</a></li>` : '',
      L.telefono ? `<li>${icon('phone')}<a href="tel:${esc(L.telefono.replace(/\s/g, ''))}">${esc(L.telefono)}</a></li>` : '',
      ui.hasWhatsApp() ? `<li>${icon('wa')}<a ${waAttrs()}>WhatsApp ${ui.waPretty()}</a></li>` : '',
      L.ciudad ? `<li>${icon('pin')}<span>${esc(L.ciudad)}</span></li>` : '',
      `<li>${icon('chat')}<a ${ui.contactAttrs()}>Formulario de contacto</a></li>`,
    ].join('');
    return `
    <footer class="site-footer">
      <svg class="footer__wave" viewBox="0 0 1440 60" preserveAspectRatio="none" aria-hidden="true"><path d="M0 30c120-20 240-20 360 0s240 20 360 0 240-20 360 0 240 20 360 0v30H0z"/></svg>
      <div class="footer__pattern wayuu" aria-hidden="true"></div>
      <div class="container footer__top">
        <div class="footer__brand">
          ${brandHTML({ dark: true, full: true })}
          <p>Nacimos para acercarte lo mejor del país y del mundo en un solo lugar. Detrás de cada producto hay un equipo que cree en hacer las cosas bien.</p>
          <ul class="footer__contact">${contact}</ul>
          <div class="footer__social">${socialLinks()}</div>
        </div>
        <nav class="footer__col" aria-label="Tienda">
          <h3>Tienda</h3>
          <a href="${R.shop}">Todos los productos</a>
          <a href="${shop({ oferta: 1 })}">Ofertas</a>
          <a href="${shop({ mejor: 1 })}">Mejor precio</a>
          <a href="${shop({ orden: 'descuento' })}">Mayores descuentos</a>
          <button type="button" data-open="wish">Mis favoritos</button>
        </nav>
        <nav class="footer__col" aria-label="Categorías">
          <h3>Categorías</h3>
          <div class="footer__cats" data-footer-cats></div>
        </nav>
        <nav class="footer__col" aria-label="Ayuda">
          <h3>Ayuda</h3>
          <a href="${policy('privacidad')}">Política de privacidad</a>
          <a href="${policy('terminos')}">Términos y condiciones</a>
          <a href="${policy('garantias')}">Cambios y garantías</a>
          <a href="${policy('retracto')}">Derecho de retracto</a>
          <a href="${policy('reversion')}">Reversión del pago</a>
          <a href="${policy('pqrs')}">PQRS</a>
        </nav>
        <div class="footer__col footer__news">
          <h3>Ofertas en tu correo</h3>
          <p>Recibe novedades y descuentos antes que nadie.</p>
          <form class="news-form" method="post" action="${esc(C.newsletterAction)}"${C.newsletterTarget === '_self' ? '' : ' target="_blank"'} accept-charset="UTF-8">
            <input type="hidden" name="form_type" value="customer">
            <input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="contact[tags]" value="newsletter,web-broworkshop">
            <label class="sr" for="news-email">Correo electrónico</label>
            <div class="news-form__row">
              <input id="news-email" type="email" name="contact[email]" placeholder="tu@correo.com" autocomplete="email" required>
              <button class="btn btn--primary" type="submit" aria-label="Suscribirme">${icon('arrow')}</button>
            </div>
            <label class="check">
              <input type="checkbox" required>
              <span>Autorizo el tratamiento de mis datos según la <a href="${policy('privacidad')}">Política de privacidad</a>.</span>
            </label>
          </form>
        </div>
      </div>
      ${ui.paymentsHTML() ? `<div class="container footer__pay">${ui.paymentsHTML()}</div>` : ''}
      <div class="container footer__legal">
        <p>© ${year} BROWORKSHOP · Todos los derechos reservados</p>
        <nav aria-label="Legal">
          <a href="${policy('privacidad')}">Privacidad</a>
          <a href="${policy('terminos')}">Términos</a>
          <a href="${policy('cookies')}">Cookies</a>
          <a href="https://www.sic.gov.co" target="_blank" rel="noopener">Superintendencia de Industria y Comercio ${icon('external')}</a>
        </nav>
        <p class="footer__made">Hecho con <span class="made-heart" aria-label="amor">♥</span> en Colombia</p>
      </div>
      <div class="tricolor tricolor--thick" aria-hidden="true"><i></i><i></i><i></i></div>
    </footer>`;
  }

  function extrasHTML() {
    return `
    <nav class="tabbar" aria-label="Navegación rápida">
      <a href="${R.home}" data-tab="inicio">${icon('home')}<span>Inicio</span></a>
      <a href="${R.shop}" data-tab="tienda">${icon('grid')}<span>Tienda</span></a>
      <button type="button" data-open="search">${icon('search')}<span>Buscar</span></button>
      <button type="button" data-open="wish">${icon('heart')}<span>Favoritos</span><i class="badge" data-wish-count hidden>0</i></button>
      <button type="button" data-open="cart" data-cart-target>${icon('bag')}<span>Carrito</span><i class="badge" data-cart-count hidden>0</i></button>
    </nav>
    <div class="floaters">
      ${ui.hasWhatsApp() ? `
      <div class="wa-widget">
        <div class="wa-bubble" data-wa-bubble role="dialog" aria-label="Mensaje de Broworkshop" hidden>
          <button class="wa-bubble__close" type="button" data-wa-dismiss aria-label="Cerrar mensaje">${icon('x')}</button>
          <div class="wa-bubble__head">
            <span class="wa-bubble__avatar"><img src="${BW.img('logo-marca.svg')}" alt=""></span>
            <div><b>Broworkshop</b><small>Atención por WhatsApp</small></div>
          </div>
          <p class="wa-bubble__msg" data-wa-msg>¡Hola! 👋 ¿Te ayudamos a encontrar lo que necesitas?</p>
          <a class="btn btn--wa btn--sm btn--block" ${waAttrs()}>${icon('wa')}Escribir por WhatsApp</a>
        </div>
        <a class="wa-float" ${waAttrs()} aria-label="Escríbenos por WhatsApp al ${ui.waPretty()}">
          <span class="wa-float__icon">${icon('wa')}</span><span class="wa-float__text">¿Te ayudamos?</span>
        </a>
      </div>` : ''}
      <button class="to-top" type="button" data-to-top aria-label="Volver arriba">
        <svg class="to-top__ring" viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="21" pathLength="100"/></svg>
        ${icon('arrow-up')}
      </button>
    </div>
    <div class="cookie" data-cookie hidden>
      <span class="cookie__icon">${icon('cookie')}</span>
      <p>Usamos cookies y almacenamiento local para que tu carrito y tus favoritos funcionen. <a href="${policy('cookies')}">Más información</a></p>
      <button class="btn btn--primary btn--sm" type="button" data-cookie-ok>Entendido</button>
    </div>`;
  }

  /* ───────────── Montaje ───────────── */
  const headerSlot = $('#bw-header');
  const footerSlot = $('#bw-footer');
  if (headerSlot) headerSlot.outerHTML = headerHTML();
  if (footerSlot) footerSlot.outerHTML = footerHTML();
  document.body.insertAdjacentHTML('beforeend', drawersHTML() + extrasHTML());

  $$(`[data-nav="${page}"], [data-tab="${page}"]`).forEach((a) => a.setAttribute('aria-current', 'page'));

  /* ───────────── Paneles laterales (drawers) ───────────── */
  let openName = null;
  let lastFocus = null;
  const hideTimers = {};
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function openDrawer(name) {
    const d = $(`[data-drawer="${name}"]`);
    if (!d) return;
    if (openName === name) return;
    if (openName) closeDrawer(openName, false);
    else lastFocus = document.activeElement;
    clearTimeout(hideTimers[name]);
    d.hidden = false;
    void d.offsetWidth;
    d.classList.add('is-open');
    document.documentElement.classList.add('is-locked');
    openName = name;
    $$(`[data-open="${name}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    hideBubble(false);
    if (name === 'search') onSearchOpen();
    if (name === 'wish') renderWish();
    const focusEl = $('[data-autofocus]', d) || $('.drawer__panel', d);
    setTimeout(() => focusEl && focusEl.focus({ preventScroll: true }), 80);
  }

  function closeDrawer(name = openName, restore = true) {
    const d = name && $(`[data-drawer="${name}"]`);
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    $$(`[data-open="${name}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    hideTimers[name] = setTimeout(() => { d.hidden = true; }, BW.motionOK() ? 380 : 0);
    if (openName === name) openName = null;
    if (restore) {
      document.documentElement.classList.remove('is-locked');
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
      lastFocus = null;
    }
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.open); return; }
    const closer = e.target.closest('[data-close]');
    if (closer) {
      const d = closer.closest('[data-drawer]');
      if (d) closeDrawer(d.dataset.drawer);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (openName) closeDrawer(openName);
      closeMega();
      return;
    }
    if (e.key === 'Tab' && openName) {
      const panel = $(`[data-drawer="${openName}"] .drawer__panel`);
      const items = $$(FOCUSABLE, panel).filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    }
    const typing = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName) || document.activeElement?.isContentEditable;
    if (!typing && !openName && (e.key === '/' || ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k'))) {
      e.preventDefault();
      openDrawer('search');
    }
  });

  ui.openDrawer = openDrawer;
  ui.closeDrawer = closeDrawer;

  /* ───────────── Menú de categorías (mega menú) ───────────── */
  const megaRoot = $('[data-mega-root]');
  const mega = $('[data-mega]');
  const megaBtn = megaRoot && $('.nav__trigger', megaRoot);
  let megaTimer = 0;

  function openMega() {
    clearTimeout(megaTimer);
    if (!mega || !mega.hidden) return;
    mega.hidden = false;
    void mega.offsetWidth;
    mega.classList.add('is-open');
    megaBtn.setAttribute('aria-expanded', 'true');
  }
  function closeMega() {
    if (!mega || mega.hidden) return;
    mega.classList.remove('is-open');
    megaBtn.setAttribute('aria-expanded', 'false');
    megaTimer = setTimeout(() => { mega.hidden = true; }, 220);
  }
  if (megaRoot) {
    megaBtn.addEventListener('click', () => (mega.hidden ? openMega() : closeMega()));
    megaRoot.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { clearTimeout(megaTimer); megaTimer = setTimeout(openMega, 90); } });
    megaRoot.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { clearTimeout(megaTimer); megaTimer = setTimeout(closeMega, 180); } });
    document.addEventListener('click', (e) => { if (!megaRoot.contains(e.target)) closeMega(); });
    megaRoot.addEventListener('focusout', (e) => { if (!megaRoot.contains(e.relatedTarget)) closeMega(); });
  }

  /* ───────────── Encabezado al hacer scroll + volver arriba ───────────── */
  const header = $('[data-header]');
  const toTop = $('[data-to-top]');
  let ticking = false;
  function onScroll() {
    ticking = false;
    const y = window.scrollY;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    if (header) header.classList.toggle('is-scrolled', y > 10);
    if (toTop) {
      toTop.classList.toggle('is-visible', y > 700);
      toTop.style.setProperty('--p', String(max > 0 ? Math.round((y / max) * 100) : 0));
    }
  }
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();
  if (toTop) toTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: BW.motionOK() ? 'smooth' : 'auto' }));

  /* ───────────── Texto animado del buscador ───────────── */
  const typer = $('[data-typer]');
  const PHRASES = ['Busca licuadoras…', 'Busca parlantes…', 'Busca cafeteras…', 'Busca ollas a presión…', 'Busca audífonos…', 'Busca secadores…'];
  if (typer && BW.motionOK()) {
    let pi = 0;
    let ci = 0;
    let deleting = false;
    const tick = () => {
      const phrase = PHRASES[pi];
      if (!document.hidden) {
        ci += deleting ? -1 : 1;
        typer.textContent = phrase.slice(0, ci) || ' ';
        if (!deleting && ci === phrase.length) { deleting = true; return setTimeout(tick, 1600); }
        if (deleting && ci === 0) { deleting = false; pi = (pi + 1) % PHRASES.length; }
      }
      return setTimeout(tick, deleting ? 35 : 70);
    };
    setTimeout(tick, 1200);
  }

  /* ───────────── Búsqueda instantánea ───────────── */
  const searchInput = $('[data-search-input]');
  const searchForm = $('[data-search-form]');
  const results = $('[data-search-results]');
  const idle = $('[data-search-idle]');
  const allLink = $('[data-search-all]');
  const POPULAR = ['licuadora', 'parlante', 'cafetera', 'audífonos', 'olla', 'secador', 'plancha', 'vajilla', 'televisor', 'portátil', 'ventilador', 'celular'];
  let catalog = null;
  let active = -1;

  function onSearchOpen() {
    searchInput.value = '';
    renderSearch('');
  }

  function setActive(i) {
    const opts = $$('[role="option"]', results);
    if (!opts.length) return;
    active = (i + opts.length) % opts.length;
    opts.forEach((o, k) => {
      o.setAttribute('aria-selected', String(k === active));
      o.classList.toggle('is-active', k === active);
    });
    searchInput.setAttribute('aria-activedescendant', opts[active].id);
    opts[active].scrollIntoView({ block: 'nearest' });
  }

  function renderSearch(q) {
    active = -1;
    searchInput.removeAttribute('aria-activedescendant');
    const query = q.trim();
    if (!query) {
      idle.hidden = false;
      results.hidden = true;
      allLink.hidden = true;
      searchInput.setAttribute('aria-expanded', 'false');
      return;
    }
    idle.hidden = true;
    results.hidden = false;
    searchInput.setAttribute('aria-expanded', 'true');
    if (!catalog) {
      results.innerHTML = '<li class="search-msg"><span class="spinner"></span> Buscando…</li>';
      return;
    }
    const tokens = BW.tokenize(query);
    const found = catalog
      .map((p) => [BW.searchScore(p, tokens), p])
      .filter(([s]) => s > 0)
      .sort((a, b) => b[0] - a[0] || a[1].rank - b[1].rank);
    if (!found.length) {
      const sug = BW.suggest(catalog, query);
      results.innerHTML = `<li class="search-msg">No encontramos “<b>${esc(query)}</b>”.
        ${sug ? `¿Quisiste decir <button type="button" class="link-btn" data-suggest="${esc(sug)}">${esc(sug)}</button>?` : 'Prueba con otra palabra o explora las categorías.'}</li>`;
      allLink.hidden = true;
      return;
    }
    results.innerHTML = found.slice(0, 7).map(([, p], i) => `
      <li role="option" id="sr-${i}" aria-selected="false" style="--d:${i * 30}ms">
        <a class="sr-item" href="${ui.productUrl(p.handle)}" tabindex="-1">
          <span class="sr-item__img tone-${catMeta(p.typeSlug).tone}"><img src="${imgUrl(p.image, 120)}" alt="" loading="lazy"></span>
          <span class="sr-item__txt"><b>${BW.highlight(p.title, query)}</b><small>${esc(p.type)}${p.discount >= 1 ? ` · <em>-${p.discount}%</em>` : ''}</small></span>
          <span class="sr-item__price">${money(p.price)}</span>
        </a>
      </li>`).join('');
    allLink.hidden = false;
    allLink.href = ui.shopUrl({ q: query });
    allLink.querySelector('span').textContent = found.length === 1 ? 'Ver el resultado en la tienda' : `Ver los ${found.length} resultados`;
  }

  if (searchInput) {
    searchInput.addEventListener('input', BW.debounce(() => renderSearch(searchInput.value), 120));
    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      if (e.key === 'Enter' && active >= 0) {
        const link = $(`#sr-${active} a`, results);
        if (link) { e.preventDefault(); window.location.href = link.href; }
      }
    });
    searchForm.addEventListener('submit', (e) => {
      if (!searchInput.value.trim()) e.preventDefault();
    });
    $('.search-panel').addEventListener('click', (e) => {
      const chip = e.target.closest('[data-suggest]');
      if (!chip) return;
      searchInput.value = chip.dataset.suggest;
      renderSearch(searchInput.value);
      searchInput.focus();
    });
  }

  /* ───────────── Carrito ───────────── */
  const cartBody = $('[data-cart-body]');
  const cartFoot = $('[data-cart-foot]');

  function lineHTML(l) {
    const m = l.merchandise || {};
    const prod = m.product || {};
    const img = (m.image && m.image.url) || (prod.featuredImage && prod.featuredImage.url) || '';
    const tone = catMeta(BW.slug(prod.productType || '')).tone;
    const unit = Number(m.price ? m.price.amount : 0);
    const compare = Number(m.compareAtPrice ? m.compareAtPrice.amount : 0);
    const url = ui.productUrl(prod.handle || '');
    return `
    <li class="line" data-line="${esc(l.id)}" data-qty="${l.quantity}">
      <a class="line__img tone-${tone}" href="${url}"><img src="${imgUrl(img, 160)}" alt="" loading="lazy"></a>
      <div class="line__info">
        <a class="line__title" href="${url}">${esc(prod.title || 'Producto')}</a>
        ${m.title && m.title !== 'Default Title' ? `<small class="line__variant">${esc(m.title)}</small>` : ''}
        <div class="line__row">
          <div class="qty qty--sm" role="group" aria-label="Cantidad">
            <button type="button" data-step="-1" aria-label="${l.quantity > 1 ? 'Quitar una unidad' : 'Eliminar del carrito'}">${icon(l.quantity > 1 ? 'minus' : 'trash')}</button>
            <output>${l.quantity}</output>
            <button type="button" data-step="1" aria-label="Agregar una unidad">${icon('plus')}</button>
          </div>
          <div class="line__price"><b>${money(l.cost.totalAmount.amount)}</b>${compare > unit ? `<s>${money(compare * l.quantity)}</s>` : ''}</div>
        </div>
        ${m.availableForSale === false ? '<p class="line__warn">Sin disponibilidad por ahora</p>' : ''}
      </div>
      <button class="line__remove" type="button" data-remove aria-label="Eliminar ${esc(prod.title || 'producto')}">${icon('x')}</button>
    </li>`;
  }

  function miniHTML(p, { removable = false } = {}) {
    const url = ui.productUrl(p.handle);
    const tone = catMeta(p.typeSlug || BW.slug(p.type || '')).tone;
    const canAdd = p.variantId && p.available !== false;
    return `
    <div class="mini" data-product-scope data-reveal>
      <a class="mini__img tone-${tone}" href="${url}"><img src="${imgUrl(p.image, 160)}" alt="" loading="lazy"></a>
      <div class="mini__info">
        <a href="${url}">${esc(p.title)}</a>
        ${ui.priceHTML(p.price, p.compare, 'price--sm')}
      </div>
      <div class="mini__actions">
        ${removable ? `<button class="icon-btn icon-btn--sm is-on" type="button" data-wish="${esc(p.handle)}" aria-label="Quitar de favoritos">${icon('heart')}</button>` : ''}
        ${canAdd
    ? `<button class="icon-btn icon-btn--soft" type="button" data-add="${esc(p.variantId)}" data-handle="${esc(p.handle)}" aria-label="Agregar al carrito: ${esc(p.title)}">${icon('plus')}</button>`
    : `<a class="icon-btn icon-btn--soft" href="${url}" aria-label="Ver ${esc(p.title)}">${icon('arrow')}</a>`}
      </div>
    </div>`;
  }

  let removingUntil = 0;
  let renderTimer = 0;
  function renderCart() {
    // Deja terminar la animación de salida de una línea antes de redibujar.
    const wait = removingUntil - Date.now();
    clearTimeout(renderTimer);
    if (wait > 0) { renderTimer = setTimeout(renderCart, wait); return; }
    const count = Cart.count;
    $$('[data-cart-count]').forEach((b) => { b.textContent = count > 99 ? '99+' : String(count); b.hidden = !count; });
    $('[data-cart-title]').innerHTML = `Tu carrito${count ? ` <span class="count-pill">${count}</span>` : ''}`;
    const lines = Cart.lines;
    if (!lines.length) {
      cartFoot.hidden = true;
      cartBody.innerHTML = ui.emptyState({
        title: 'Tu carrito está vacío',
        text: 'Descubre productos que harán tu casa más bonita y práctica.',
        actions: `<a class="btn btn--primary" href="${R.shop}">Explorar la tienda ${icon('arrow')}</a>`,
        art: 'bag',
      }) + '<div class="drawer__suggest" data-cart-suggest></div>';
      fillSuggestions();
      ui.reveal(cartBody);
      return;
    }
    cartFoot.hidden = false;
    cartBody.innerHTML = `<ul class="lines">${lines.map(lineHTML).join('')}</ul>`;
    $('[data-cart-subtotal]').textContent = money(Cart.data.cost.subtotalAmount.amount);
    const saved = lines.reduce((sum, l) => {
      const m = l.merchandise || {};
      const unit = Number(m.price ? m.price.amount : 0);
      const cmp = Number(m.compareAtPrice ? m.compareAtPrice.amount : 0);
      return sum + (cmp > unit ? (cmp - unit) * l.quantity : 0);
    }, 0);
    const save = $('[data-cart-save]');
    save.hidden = saved <= 0;
    save.innerHTML = `${icon('sparkles')}¡Estás ahorrando <b>${money(saved)}</b> en esta compra!`;
    const checkout = $('[data-checkout]');
    checkout.href = Cart.data.checkoutUrl;
    const waCart = $('[data-wa-cart]');
    if (waCart) waCart.href = ui.waLink(cartWaText(lines));
  }

  /** Resumen del carrito para enviarlo por WhatsApp. */
  function cartWaText(lines) {
    const rows = lines.map((l) => {
      const m = l.merchandise || {};
      const title = (m.product && m.product.title) || 'Producto';
      const variant = m.title && m.title !== 'Default Title' ? ` (${m.title})` : '';
      return `• ${l.quantity} × ${title}${variant}: ${money(l.cost.totalAmount.amount)}`;
    });
    const shown = rows.slice(0, 15);
    if (rows.length > 15) shown.push(`…y ${rows.length - 15} productos más`);
    return [
      '¡Hola Broworkshop! 👋 Quiero hacer este pedido:',
      ...shown,
      `*Subtotal: ${money(Cart.data.cost.subtotalAmount.amount)}*`,
      `Pedido armado en ${C.publicUrl.replace(/^https?:\/\//, '')}`,
    ].join('\n');
  }

  function fillSuggestions() {
    const box = $('[data-cart-suggest]');
    if (!box) return;
    BW.loadCatalog().then((items) => {
      const picks = items.filter((p) => p.available && p.variantId).slice(0, 3);
      if (!picks.length || !document.contains(box)) return;
      box.innerHTML = `<p class="eyebrow-sm">Te puede gustar</p>${picks.map((p) => miniHTML(p)).join('')}`;
      ui.reveal(box);
    }).catch(() => {});
  }

  cartBody.addEventListener('click', async (e) => {
    const line = e.target.closest('.line');
    const step = e.target.closest('[data-step]');
    const remove = e.target.closest('[data-remove]');
    if (!line || (!step && !remove) || line.classList.contains('is-busy')) return;
    const qty = Number(line.dataset.qty);
    const next = remove ? 0 : qty + Number(step.dataset.step);
    line.classList.add('is-busy');
    if (next <= 0) {
      line.classList.add('is-removing');
      removingUntil = Date.now() + 360;
    }
    else { line.dataset.qty = String(next); $('output', line).textContent = String(next); }
    try {
      await Cart.update(line.dataset.line, next);
    } catch (err) {
      console.error(err);
      removingUntil = 0;
      line.classList.remove('is-removing', 'is-busy');
      ui.toast({ type: 'error', title: 'No pudimos actualizar tu carrito', text: err.message });
      renderCart();
    }
  });

  $('[data-checkout]').addEventListener('click', (e) => {
    if (!Cart.data || !Cart.data.checkoutUrl) { e.preventDefault(); return; }
    e.currentTarget.classList.add('is-busy');
  });

  Cart.subscribe(renderCart);

  /* ───────────── Favoritos ───────────── */
  function renderWish() {
    const count = Wish.count;
    $$('[data-wish-count]').forEach((b) => { b.textContent = String(count); b.hidden = !count; });
    const title = $('[data-wish-title]');
    if (title) title.innerHTML = `Tus favoritos${count ? ` <span class="count-pill">${count}</span>` : ''}`;
    const body = $('[data-wish-body]');
    if (!body) return;
    if (!count) {
      body.innerHTML = ui.emptyState({
        title: 'Aún no tienes favoritos',
        text: 'Toca el corazón de cualquier producto y lo guardamos aquí para que lo encuentres rápido.',
        actions: `<a class="btn btn--primary" href="${R.shop}">Descubrir productos ${icon('arrow')}</a>`,
        art: 'heart',
      });
    } else {
      body.innerHTML = `<div class="minis">${Wish.items.map((i) => miniHTML({ ...i, ...(BW.index.get(i.handle) || {}) }, { removable: true })).join('')}</div>`;
    }
    ui.reveal(body);
  }
  Wish.subscribe(renderWish);
  renderWish();

  /* ───────────── Menús con categorías reales ───────────── */
  function fillMenus(items) {
    catalog = items;
    if (Cart.count) renderCart();
    const cats = BW.categoriesOf(items);
    const plural = (n) => `${n} producto${n === 1 ? '' : 's'}`;

    const grid = $('[data-mega-grid]');
    if (grid) {
      grid.innerHTML = cats.map((c, i) => `
        <a class="mega__link" href="${ui.shopUrl({ cat: c.slug })}" style="--i:${i}">
          <span class="mega__icon tone-${c.tone}">${icon(c.icon)}</span>
          <span><b>${esc(c.name)}</b><small>${plural(c.count)}</small></span>
        </a>`).join('') + `
        <a class="mega__link mega__link--all" href="${R.shop}" style="--i:${cats.length}">
          <span class="mega__icon">${icon('grid')}</span><span><b>Ver todo</b><small>${plural(items.length)}</small></span>
        </a>`;
    }

    const deal = items.filter((p) => p.available && p.discount > 0).sort((a, b) => b.discount - a.discount)[0];
    const promo = $('[data-mega-promo]');
    if (promo && deal) {
      promo.innerHTML = `
        <a class="mega__promo" href="${ui.productUrl(deal.handle)}">
          <span class="mega__promo-tag">Oferta destacada · -${deal.discount}%</span>
          <span class="mega__promo-img"><img src="${imgUrl(deal.image, 360)}" alt="" loading="lazy"></span>
          <b>${esc(deal.title)}</b>
          ${ui.priceHTML(deal.price, deal.compare)}
          <span class="mega__promo-cta">Ver oferta ${icon('arrow')}</span>
        </a>`;
    }

    const mcats = $('[data-mnav-cats]');
    if (mcats) {
      mcats.innerHTML = cats.map((c) => `
        <a class="mcat" href="${ui.shopUrl({ cat: c.slug })}">
          <span class="mega__icon tone-${c.tone}">${icon(c.icon)}</span>
          <span>${esc(c.name)}</span><small>${c.count}</small>
        </a>`).join('');
    }

    const scats = $('[data-search-cats]');
    if (scats) {
      scats.innerHTML = cats.slice(0, 10).map((c) => `<a class="chip" href="${ui.shopUrl({ cat: c.slug })}">${icon(c.icon)}${esc(c.name)}</a>`).join('');
    }
    const pop = $('[data-search-popular]');
    if (pop) {
      pop.innerHTML = POPULAR
        .filter((w) => items.some((p) => BW.searchScore(p, BW.tokenize(w)) > 0))
        .slice(0, 8)
        .map((w) => `<button class="chip chip--soft" type="button" data-suggest="${esc(w)}">${icon('search')}${esc(w)}</button>`)
        .join('');
    }

    const fcats = $('[data-footer-cats]');
    if (fcats) fcats.innerHTML = cats.slice(0, 7).map((c) => `<a href="${ui.shopUrl({ cat: c.slug })}">${esc(c.name)}</a>`).join('');

    if (searchInput && !$('[data-drawer="search"]').hidden) renderSearch(searchInput.value);
  }

  BW.loadCatalog().then(fillMenus).catch((err) => {
    console.error('[catálogo]', err);
    const grid = $('[data-mega-grid]');
    if (grid) grid.innerHTML = '<p class="muted">No pudimos cargar las categorías.</p>';
  });

  Cart.init();

  /* ───────────── Aviso de cookies ───────────── */
  const cookie = $('[data-cookie]');
  if (cookie && !BW.local.get('bw:cookies')) {
    setTimeout(() => {
      cookie.hidden = false;
      document.body.classList.add('has-cookie');
      requestAnimationFrame(() => cookie.classList.add('is-open'));
    }, 1800);
    $('[data-cookie-ok]', cookie).addEventListener('click', () => {
      BW.local.set('bw:cookies', { ok: true, t: Date.now() });
      cookie.classList.remove('is-open');
      document.body.classList.remove('has-cookie');
      setTimeout(() => { cookie.hidden = true; }, 400);
    });
  }

  /* ───────────── Saludo de WhatsApp ───────────── */
  function hideBubble(remember = true) {
    const bubble = $('[data-wa-bubble]');
    if (remember) BW.session.set('bw:wa-saludo', 1);
    if (!bubble || bubble.hidden) return;
    bubble.classList.add('is-leaving');
    setTimeout(() => { bubble.hidden = true; bubble.classList.remove('is-leaving'); }, 280);
  }

  const bubble = $('[data-wa-bubble]');
  if (bubble && C.whatsappGreeting !== false && !BW.session.get('bw:wa-saludo')) {
    setTimeout(() => {
      if (openName || BW.session.get('bw:wa-saludo')) return;
      const msg = $('[data-wa-msg]', bubble);
      const text = msg.innerHTML;
      msg.innerHTML = '<span class="typing" aria-label="Escribiendo"><i></i><i></i><i></i></span>';
      bubble.hidden = false;
      setTimeout(() => { msg.innerHTML = text; }, BW.motionOK() ? 1400 : 0);
    }, 8000);
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-wa-dismiss]')) hideBubble();
    else if (e.target.closest('[data-wa], [data-wa-cart]')) hideBubble();
  });

  ui.reveal();
})();
